import * as React from 'react';
import { useSelector } from 'react-redux';
import { EMediaType, TMedia } from 'shared/components/NewbuildingGallery';
import {
  NewbuildingBrokerGalleryBookingBannerContainer,
  NewbuildingBrokerGalleryDIYBannerContainer,
} from 'shared/containers/NewbuildingBrokerGalleryBanner';
import { NewbuildingPushToCallBannerContainer } from 'shared/containers/NewbuildingPushToCallBanner';
import { isNewbuildingSelector } from 'shared/selectors';
import { getOffer } from 'shared/selectors/newObject';
import { selectDIYEnabled } from 'shared/selectors/newbuildingBrokerDIY';
import { selectOfferBookingEnabled } from 'shared/selectors/newbuildingBrokerOfferBooking';
import { isLeadFactory } from 'shared/utils/agent';

export const useMiddleBanner = (thumbnailSrc: string): TMedia | null => {
  const isNewbuilding = useSelector(isNewbuildingSelector);
  const offer = useSelector(getOffer);
  const isOfferBookingEnabled = useSelector(selectOfferBookingEnabled);
  const isDIYEnabled = useSelector(selectDIYEnabled);

  return React.useMemo<TMedia | null>(() => {
    if (!isNewbuilding) {
      return null;
    }

    const isFromDeveloper = Boolean(offer.newbuilding?.isFromDeveloper);
    const isPushToCallAvailable = isFromDeveloper && !isLeadFactory(offer);

    let component: React.JSX.Element | undefined;

    if (isOfferBookingEnabled) {
      component = <NewbuildingBrokerGalleryBookingBannerContainer />;
    } else if (isDIYEnabled) {
      component = <NewbuildingBrokerGalleryDIYBannerContainer />;
    } else if (isPushToCallAvailable) {
      component = <NewbuildingPushToCallBannerContainer />;
    }

    if (!component) {
      return null;
    }

    return {
      type: EMediaType.Component,
      component,
      thumbnailSrc,
    };
  }, [isNewbuilding, thumbnailSrc, offer, isOfferBookingEnabled, isDIYEnabled]);
};
